import store from "@/store";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import OrderDetails from "@/views/HotelViews/OrderDetails.vue";
import HotelPlaceOrder from "@/views/HotelViews/HotelPlaceOrder.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "PlaceOrder",
    component: HotelPlaceOrder,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Auth/Login.vue"),
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: "/auth",
    name: "LoginWebsite",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Auth/LoginWebsite.vue"),
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: "/reset-password-email",
    name: "ResetPasswordEmail",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Auth/ResetPasswordEmail.vue"),
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Auth/ResetPassword.vue"),
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: "/upcoming-orders",
    name: "UpcomingOrders",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/UpcomingOrders.vue"),
  },
    {
    path: "/order-history",
    name: "OrderHistory",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/OrderHistory.vue"),
  },
  // {
  //   path: "/messages",
  //   name: "Messages",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/Messages.vue"),
  // },
  // {
  //   path: "/linked_accounts",
  //   name: "LinkedAccounts",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/LinkedAccounts.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     passengerType: "COMPANY",
  //   },
  // },
  // {
  //   path: "/company_expenses",
  //   name: "CompanyExpenses",
  //   component: () => import("../views/CompanyExpenses.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     passengerType: "COMPANY",
  //   },
  // },
  // {
  //   path: "/expenses",
  //   name: "Expenses",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/Expenses.vue"),
  //   meta: {
  //     requiresAuth: true,
  //     passengerType: "COMPANY",
  //   },
  // },

  // {
  //   path: "/details",
  //   redirect: "/",
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
  // {
  //   path: "/details/:id",
  //   name: "Details",
  //   component: OrderDetails,
  //   meta: {
  //     breadcrumb: true,
  //     requiresAuth: true,
  //   },
  //   props: (route) => ({
  //     ...route.params,
  //   }),
  // },
  {
    path: "/notifications",
    name: "Notifications",
    component: OrderDetails,
    meta: {
      requiresAuth: true,
    },
  },
  // {
  //   path: "/payment-method",
  //   name: "PaymentMethod",
  //   component: PaymentMethod,
  //   meta: {
  //     requiresAuth: true,
  //     passengerType: "COMPANY",
  //   },
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, _from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.loggedIn) {
      console.log("MUST NOT BE LOGGED");
      next({ name: "Login" });
    } else {
      // Logged in
      store.dispatch("initSocket");
      if (
        to.meta?.passengerType &&
        to.meta.passengerType != store.getters.getUser.type
      ) {
        next({ name: "PlaceOrder" });
      } else {
        // var Inactive_cards = 0;

        // store.getters.getUser.company_cards.forEach(
        //   (item: { status: any }) => {
        //     if (item.status == "INACTIVE") {
        //       Inactive_cards++;
        //     }
        //   }
        // );
        next();

      }
    }
  } else if (to.matched.some((record) => record.meta.requiresVisitor)) {
    console.log("MUST BE LOGGED");
    if (store.getters.loggedIn) next({ name: "PlaceOrder" });
    else next();
  } else {
    next();
  }
});

export default router;
